import { useHistory } from 'react-router'
import { Button, Grid, Typography } from '@mui/material'

import * as routes from '../../routes'
import { ReactComponent as Package } from '../../assets/icons/package.svg'
import useTranslations from '../../i18n/useTranslations'
import EmptyStateWrapper from '../../ui/components/EmptyState/PaperWrapper'

const EmptyState = () => {
  const t = useTranslations()
  const history = useHistory()

  const goToShippingSend = () => {
    history.push(routes.SHIPPING_SEND.linkTo())
  }

  return (
    <Grid container spacing={4}>
      <Grid item xs>
        <EmptyStateWrapper extraClass="big">
          <Typography variant="h1">{t('empty:no-shipment-request')}</Typography>
          <Typography sx={{ color: 'neutral.main' }}>
            {t('empty:no-incident-shipments')}
          </Typography>
          <Button startIcon={<Package />} onClick={goToShippingSend}>
            {t('empty:want-first-shipment')}
          </Button>
        </EmptyStateWrapper>
      </Grid>
    </Grid>
  )
}

EmptyState.propTypes = {}

export default EmptyState
